export const FETCH_PRACTICELIST_REQUEST = "FETCH_PRACTICELIST_REQUEST";
export const FETCH_PRACTICELIST_SUCCESS = "FETCH_PRACTICELIST_SUCCESS";
export const FETCH_PRACTICELIST_FAILURE = "FETCH_PRACTICELIST_FAILURE";
